import { render } from "./equipment.vue?vue&type=template&id=248e4860&scoped=true"
import script from "./equipment.vue?vue&type=script&lang=js"
export * from "./equipment.vue?vue&type=script&lang=js"

import "./equipment.vue?vue&type=style&index=0&id=248e4860&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-248e4860"]])

export default __exports__